//GOOGLE_RECAPTCHA_SITE_KEY: '6LcytQYTAAAAAI6aT-fMFD2HOR8stZa6dBonuAWZ',  //prod Key
//GOOGLE_RECAPTCHA_SITE_KEY: '6Ld_SoAUAAAAAG2Frly42MuOMp_NW3-vaf5tixD0', //Test Key

const recaptchaKey = process.env.GOOGLE_RECAPTCHA_SITE_KEY || '6LcytQYTAAAAAI6aT-fMFD2HOR8stZa6dBonuAWZ';

const CaptchaKeys = {
  GOOGLE_RECAPTCHA_SITE_KEY: recaptchaKey
};

console.log('Google Recaptcha Key:', CaptchaKeys.GOOGLE_RECAPTCHA_SITE_KEY);
console.log('recaptchaKey: ', recaptchaKey);

export default CaptchaKeys;